/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LibModelsEditSource,
    LibModelsEditSourceFromJSON,
    LibModelsEditSourceFromJSONTyped,
    LibModelsEditSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface LibModelsEdit
 */
export interface LibModelsEdit {
    /**
     * 
     * @type {string}
     * @memberof LibModelsEdit
     */
    editId?: string;
    /**
     * 
     * @type {Date}
     * @memberof LibModelsEdit
     */
    timestamp?: Date;
    /**
     * 
     * @type {LibModelsEditSource}
     * @memberof LibModelsEdit
     */
    source?: LibModelsEditSource;
}

export function LibModelsEditFromJSON(json: any): LibModelsEdit {
    return LibModelsEditFromJSONTyped(json, false);
}

export function LibModelsEditFromJSONTyped(json: any, ignoreDiscriminator: boolean): LibModelsEdit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'editId': !exists(json, 'edit_id') ? undefined : json['edit_id'],
        'timestamp': !exists(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
        'source': !exists(json, 'source') ? undefined : LibModelsEditSourceFromJSON(json['source']),
    };
}

export function LibModelsEditToJSON(value?: LibModelsEdit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'edit_id': value.editId,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
        'source': LibModelsEditSourceToJSON(value.source),
    };
}


